export default __webpack_public_path__ + "static/media/Logo.1846fd0a.png";